/* ═══════════════════════════════════════════════════════════════
   Timesheets rebuild — Reject-with-reason dialog (Tranche 2, new).
   ═══════════════════════════════════════════════════════════════ */

import React, { useState } from 'react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from '../../components/ui/dialog';
import { Button } from '../../components/ui/button';

export interface RejectReasonDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  memberName?: string;
  busy?: boolean;
  onConfirm: (reason: string) => void;
}

export function RejectReasonDialog({
  open,
  onOpenChange,
  memberName,
  busy,
  onConfirm,
}: RejectReasonDialogProps) {
  const [reason, setReason] = useState('');

  return (
    <Dialog
      open={open}
      onOpenChange={(o) => {
        if (!busy) {
          onOpenChange(o);
          if (!o) setReason('');
        }
      }}
    >
      <DialogContent className="max-w-sm">
        <DialogHeader>
          <DialogTitle>Reject {memberName ? `${memberName}'s` : 'this'} timesheet</DialogTitle>
        </DialogHeader>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 'var(--space-2)' }}>
          <label
            htmlFor="reject-reason"
            style={{ fontSize: 'var(--font-size-sm)', fontWeight: 600, color: 'var(--tm)' }}
          >
            Reason (sent back to draft)
          </label>
          <textarea
            id="reject-reason"
            autoFocus
            rows={3}
            value={reason}
            onChange={(e) => setReason(e.target.value)}
            placeholder="What needs to change before resubmitting?"
            style={{
              padding: 'var(--space-2) var(--space-3)',
              borderRadius: 'var(--radius-sm)',
              border: '1px solid var(--bd)',
              background: 'var(--ib)',
              color: 'var(--tx)',
              fontSize: 'var(--font-size-base)',
              resize: 'vertical',
              boxSizing: 'border-box',
            }}
          />
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)} disabled={busy}>
            Cancel
          </Button>
          <Button variant="destructive" onClick={() => onConfirm(reason)} disabled={busy}>
            {busy ? 'Rejecting…' : 'Reject'}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
